import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import RichEditor from "../../RichEditor/components/RichEditor";

import { stateFromHTML } from "draft-js-import-html";
import { stateToHTML } from "draft-js-export-html";
import { EditorState } from "draft-js";

const stateToHTMLOptions = {
  entityStyleFn: (entity) => {
    if (entity.getType().toUpperCase() !== "LINK") return undefined;

    const data = entity.getData() || {};
    const { url, targetOption } = data;
    const attributes = { href: url };

    if (targetOption && targetOption !== "_self") {
      attributes.target = targetOption;
      attributes.rel = "noopener noreferrer";
    }

    return {
      element: "a",
      attributes,
    };
  },
};

const stateFromHTMLOptions = {
  customInlineFn: (element, { Entity }) => {
    if (element.nodeName !== "A") return null;

    const url = element.getAttribute("href");
    if (!url) return null;

    const target = element.getAttribute("target");

    return Entity(
      "LINK",
      {
        url,
        targetOption: target || "_self",
      },
      "MUTABLE"
    );
  },
};

const boxStyle = {
  padding: 0,
};

const buttonStyle = {
  alignSelf: "center",
};

const rowStyle = {
  display: "flex",
  flexDirection: "row",
};

const FAN_TAG_NAME_MAX_LENGTH = 50;

const VenueAgreementRow = ({
  agreement,
  onChange,
  onDelete,
}) => {
  const [agreementBody, setAgreementBody] = useState(
    EditorState.createWithContent(stateFromHTML(agreement.body, stateFromHTMLOptions))
  );

  const required = agreement.required !== false;

  return (
    <>
      <div 
        className={"row col-12"}
        style={{
          fontSize: "10pt",
          marginBottom: "10px",
          marginTop: "10px",
        }}
      >
        <strong>Agreement</strong>
      </div>
      <div className={"formRow"} style={rowStyle}>
        <div className={"col col-11"} style={boxStyle}>
          <RichEditor
            editorState={agreementBody}
            onEditorStateChange={
              (editorState) => {
                setAgreementBody(editorState);
                onChange({
                  ...agreement,
                  body: stateToHTML(editorState.getCurrentContent(), stateToHTMLOptions),
                })
              }
            } />
        </div>
        <div className={"col col-1"} style={buttonStyle}>
          <a href="#"
            className="text-muted ml-2"
            onClick={
              (e) => {
                e.preventDefault();

                if(window.confirm("Are you sure?")){
                  onDelete(agreement);
                }
              }
            }>
            <i className="fa-light fa-trash"></i>
          </a>
        </div>
      </div>
      <div className={"formRow col-12"} style={boxStyle}>
        <div className="custom-control custom-checkbox">
          <input
            type="checkbox"
            className="custom-control-input"
            id={`venue-agreement-required-${agreement.id || agreement.index}`}
            checked={required}
            onChange={(e) => onChange({ ...agreement, required: e.target.checked })}
          />
          <label
            className="custom-control-label small"
            htmlFor={`venue-agreement-required-${agreement.id || agreement.index}`}
          >
            Required to complete purchase
          </label>
        </div>
        <p className="m-0 small text-muted" style={{ paddingLeft: "24px" }}>
          Leave unchecked for an opt-in the buyer can skip, such as a sponsor mailing
          list. A consent that blocks the sale is not a valid marketing opt-in.
        </p>
        <div style={{ marginTop: "10px", maxWidth: "340px" }}>
          <label className="small text-muted mb-1" htmlFor={`venue-agreement-fan-tag-${agreement.id || agreement.index}`}>
            Tag accepting contacts with
          </label>
          <input
            type="text"
            className="form-control"
            id={`venue-agreement-fan-tag-${agreement.id || agreement.index}`}
            maxLength={FAN_TAG_NAME_MAX_LENGTH}
            placeholder="e.g. TAYO Opt-In — Jun 14"
            value={agreement.fan_tag_name || ""}
            onChange={(e) => onChange({ ...agreement, fan_tag_name: e.target.value })}
          />
          <p className="m-0 small text-muted" style={{ marginTop: "4px" }}>
            Applied to the contact when they accept, so the list is filterable in
            Contacts and usable as a data driven segment.
          </p>
        </div>
      </div>
    </>
  );
};

VenueAgreementRow.propTypes = {
  agreement: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default VenueAgreementRow;
